import { buildUrl } from "helpers";
import { instance } from "libs/api";

import {
  ApiRoutesSupport,
  SupportConversationSubRoute
} from "../../constants/enums";
import { InAppConversation } from "../../support.types";

export const requestMarkReadConversation = async (
  conversationId: string
): Promise<InAppConversation> => {
  return await instance.post(
    buildUrl(
      ApiRoutesSupport.Conversations,
      conversationId,
      SupportConversationSubRoute.MarkRead
    )
  );
};
